import * as ProfileTypes from 'domain/fuse/auth/profiles/actionTypes';
import { getSelectedProfileFromStorage } from 'domain/fuse/auth/profiles/utils';

const initialState = {
  profile: getSelectedProfileFromStorage(),
};

export default (state = initialState, action) => {
  switch (action.type) {
    case ProfileTypes.INITIALIZED:
    case ProfileTypes.SELECT: {
      const {
        payload: { profile },
      } = action;
      // TODO
      // Maybe should be inner reducer
      return { ...state, profile };
    }
    case ProfileTypes.UPDATE: {
      return {
        ...state,
        profile: {
          ...state.profile,
          ...action.payload.profile,
        },
      };
    }
    default:
      return state;
  }
};
